import { Component } from '@theme/component';

export class NamaiTarot extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.start();
  }
  updatedCallback() {
    super.updatedCallback();
    this.start();
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    this.controller?.abort();
    clearTimeout(this.midnight);
  }
  start() {
    this.controller?.abort();
    this.controller = new AbortController();
    this.data = JSON.parse(this.refs.data.textContent);
    this.key = 'namai-daily-tarot-v1';
    this.currentDay = this.day();
    this.memory = null;
    this.restore();
    const signal = this.controller.signal;
    window.addEventListener('storage', () => this.restore(), { signal });
    window.addEventListener('pageshow', () => this.restore(), { signal });
    document.addEventListener('visibilitychange', () => { if (!document.hidden) this.restore(); }, { signal });
    this.schedule();
  }
  day() {
    const date = new Date();
    return `${date.getFullYear()}-${String(date.getMonth()+1).padStart(2,'0')}-${String(date.getDate()).padStart(2,'0')}`;
  }
  schedule() {
    clearTimeout(this.midnight);
    const now = new Date();
    const next = new Date(now.getFullYear(), now.getMonth(), now.getDate()+1);
    this.midnight = setTimeout(() => { this.restore(); this.schedule(); }, next - now + 100);
  }
  read() {
    let saved = this.memory;
    try { saved = JSON.parse(localStorage.getItem(this.key)) || saved; } catch {}
    if (saved?.day !== this.day() || !Number.isInteger(saved.choice) || saved.choice < 0 || saved.choice > 2 || !this.data.deck.some(card => card.id === saved.card)) return null;
    return saved;
  }
  restore() {
    const changedDay = this.currentDay !== this.day();
    this.currentDay = this.day();
    if (changedDay) this.memory = null;
    const draft = !changedDay && !this.refs.reading.hidden ? this.refs.journal.value : null;
    const saved = this.read();
    this.refs.spread.hidden = false;
    this.querySelectorAll('[data-choice]').forEach(button => {
      button.disabled = Boolean(saved);
      button.classList.remove('is-picked', 'is-muted');
      button.removeAttribute('aria-pressed');
    });
    this.refs.reading.hidden = !saved;
    if (saved) { this.reveal(saved, false); if (draft !== null) this.refs.journal.value = draft; }
    else {
      this.refs.journal.value = '';
      this.refs.status.textContent = this.data.messages.choose;
    }
  }
  choose(event) {
    const target = event.target;
    if (!(target instanceof HTMLButtonElement)) return;
    const existing = this.read();
    if (existing) { this.reveal(existing, true); return; }
    if (this.currentDay !== this.day()) this.restore();
    const values = new Uint32Array(3);
    crypto.getRandomValues(values);
    const indices = this.data.deck.map((_, i) => i);
    const hand = Array.from(values, value => indices.splice(value % indices.length, 1)[0]);
    const choice = Number(target.dataset.choice);
    const saved = { day:this.day(), card:this.data.deck[hand[choice]].id, choice, journal:'' };
    this.memory = saved;
    let persisted = true;
    try { localStorage.setItem(this.key, JSON.stringify(saved)); } catch { persisted = false; }
    this.reveal(saved, true);
    if (!persisted) this.refs.status.textContent = this.data.messages.unavailable;
    window.dispatchEvent(new CustomEvent('namai:daily-card'));
  }
  reveal(saved, focus) {
    const card = this.data.deck.find(item => item.id === saved.card);
    if (!card) return;
    this.querySelectorAll('[data-choice]').forEach(button => {
      const picked = Number(button.dataset.choice) === saved.choice;
      button.disabled = true;
      button.classList.toggle('is-picked', picked);
      button.classList.toggle('is-muted', !picked);
      button.setAttribute('aria-pressed', String(picked));
      button.querySelector('[data-card-name]').textContent = picked ? card.name : '';
    });
    this.refs.cardName.textContent = card.name;
    this.refs.meaning.textContent = card.meaning;
    this.refs.affirmation.textContent = card.affirmation;
    this.refs.prompt.textContent = card.prompt;
    this.refs.journal.value = typeof saved.journal === 'string' ? saved.journal : '';
    this.refs.reading.hidden = false;
    this.refs.status.textContent = this.data.messages.revealed;
    if (focus) this.refs.cardName.focus({ preventScroll:true });
  }
  save() {
    const saved = this.read();
    if (!saved) { this.restore(); return; }
    saved.journal = this.refs.journal.value.slice(0,8000);
    this.memory = saved;
    try { localStorage.setItem(this.key, JSON.stringify(saved)); this.refs.status.textContent = this.data.messages.saved; }
    catch { this.refs.status.textContent = this.data.messages.unavailable; }
  }
  clear() {
    this.refs.journal.value = '';
    const saved = this.read();
    if (saved) {
      saved.journal = '';
      this.memory = saved;
      try { localStorage.setItem(this.key, JSON.stringify(saved)); } catch { this.refs.status.textContent = this.data.messages.unavailable; return; }
    }
    this.refs.status.textContent = this.data.messages.cleared;
  }
}
if (!customElements.get('namai-tarot-component')) customElements.define('namai-tarot-component', NamaiTarot);
